module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('section', {
    staticClass: "main_section",
    class: {
      'pic--1': true
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md8": "",
      "offset-md2": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('strong', [_vm._v("活動期間")]), _c('p', [_vm._v("2019/02/12 - 2019/02/17")]), _vm._v(" "), _c('strong', [_vm._v("使用方式")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("消費滿1500元，於結帳前出示此折價卷畫面即可享有100元折扣優惠")])]), _vm._v(" "), _c('strong', [_vm._v("注意事項")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("單筆消費限用一次。")]), _vm._v(" "), _c('li', [_vm._v("此抵用卷限2019台北國際書展LiveABC攤位(B1225)使用。")]), _vm._v(" "), _c('li', [_vm._v("請於結帳前出示折價卷給收銀人員，結帳後恕無法補登。")]), _vm._v(" "), _c('li', [_vm._v("LiveABC保留活動修改之權利。")])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "text-xs-center mt-5"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/special_event2019/pic_coupon.jpg"),
      "width": "80%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c21bdd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/events/tibeSpecial2019.vue
// module id = 775
// module chunks = 1